/* eslint-disable jsx-a11y/accessible-emoji */
import $ST from "plugins/tfs/platformConfigs/staticTextMaps/checkout";
import $R from "plugins/tfs/platformConfigs/integrationMaps/routes";
import $CT from "plugins/tfs/platformConfigs/theme/checkout";
import React from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import Agreement from "../agreement";
import CheckoutSummary from "theme/checkout/CheckoutSummary";
import CheckoutTab from "theme/checkout/CheckoutTab";
import CheckoutContent from "theme/checkout/CheckoutContent";
import AddressSelection from "theme/checkout/tfs/AddressSelection";
import CargoSelection from "theme/checkout/CargoSelection";
import PaymentSelection from "theme/checkout/PaymentSelectionTFS";
import Spinner from "theme/Spinner";
import Button from "theme/Button";
import ModalSpinner from "theme/ModalSpinner";
import { customerLogout } from "actions/customerList";
import { CASH_PAYMENT_TYPE } from "constants/checkout";
import { isDefined } from "utils/index";

// pageContainer
import Checkout from "_pageContainers/checkout/checkout";

const $AF = $ST.DIRECTORY_THEME.ADDRESS_FORM;

const CheckoutGrid = (pageContext) => {
  const {
    props: {
      pending,
      modalPending,
      preOrder,
      context,
      customer,
      error,
      qrUrl,
      orderStatusUrl,
    },
    tab,
    tabChangable,
    agreement,
    cardId,
    installmentId,
    giftBoxChecked,
    changeTab,
    paymentType,
    onSetAgreement,
    onSetDeliveryOptionWithAddress,
    onSetDeliveryOption,
    onSetAddress,
    onSetRetailStore,
    onSetShippingOption,
    onSetPaymentOption,
    onSelectInstallmentOption,
    onSetInstallmentOption,
    onSelectInstallmentId,
    onSetPaymentType,
    onFetchCountries,
    onFetchCities,
    onFetchTownships,
    onFetchDistricts,
    onSendAddress,
    onDeleteAddress,
    handleCardSelection,
    handleChange,
    onSetFundsTransferChoicePage,
    onSetPaymentFundTransfer,
  } = pageContext;

  const dispatch = useDispatch();

  if (context.thankyou) {
    if (paymentType === CASH_PAYMENT_TYPE) {
      dispatch(customerLogout());
    }

    return <Redirect to={$R.CHECKOUT_THANK_YOU.path} />;
  }

  return (
    <div className="checkout headerMargin">
      {!pending && error && error.message}
      {pending && <Spinner />}
      {!pending && (
        <div className="container-fluid">
          {modalPending && <ModalSpinner />}
          <div className="row">
            <div className="col-xs-12 col-lg-9 checkout-wrapperPadding">
              <div className="checkout-body">
                <div className="checkout-tabs">
                  <CheckoutTab
                    active={tab === 0}
                    title={$ST.FIRST_TAB_TITLE}
                    onClick={() => changeTab(0)}
                  >
                    {preOrder.shipping_address && (
                      <p>
                        <p>{preOrder.shipping_address.title}</p>
                        <span>
                          {isDefined(preOrder.shipping_address.district) &&
                          isDefined(preOrder.shipping_address.district.name)
                            ? preOrder.shipping_address.district.name
                            : ""}{" "}
                        </span>
                        <span>
                          {(preOrder.shipping_address.line || "")
                            .split($AF.SEPERATOR)
                            .join($AF.CONCATENATOR)}{" "}
                        </span>
                        <span>{preOrder.shipping_address.city.name} </span>
                        <span>
                          {preOrder.shipping_address.township.name} /{" "}
                          {preOrder.shipping_address.country.name}{" "}
                        </span>
                        <span>
                          {$ST.PHONE}: {preOrder.shipping_address.phone_number}
                        </span>
                      </p>
                    )}
                  </CheckoutTab>
                  <CheckoutTab
                    active={tab === 1}
                    title={$ST.SECOND_TAB_TITLE}
                    onClick={() => changeTab(1)}
                  >
                    <p>{$ST.SECOND_TAB_DESCRIPTION}</p>
                  </CheckoutTab>
                </div>
                <div className="checkout-contents">
                  {tab === 0 && (
                    <CheckoutContent>
                      <div className="row">
                        <div className="col-xs-12 col-md-8 checkout-contents-wrapper__pr">
                          {context.addresses && (
                            <AddressSelection
                              retail_stores={context.retail_stores || []}
                              deliveryOptions={context.delivery_options || []}
                              currentDeliveryOption={
                                preOrder.delivery_option || {}
                              }
                              addresses={context.addresses || []}
                              currentAddress={preOrder.shipping_address || {}}
                              currentBillAddress={
                                preOrder.billing_address || {}
                              }
                              currentRetailStore={preOrder.retail_store || {}}
                              countries={context.countries || []}
                              cities={context.cities || []}
                              districts={context.districts || []}
                              townships={context.townships || []}
                              customer={customer}
                              setDeliveryOptionWithAddress={(
                                address,
                                billingAddress,
                                deliveryOption
                              ) => {
                                onSetDeliveryOptionWithAddress(
                                  address,
                                  billingAddress,
                                  deliveryOption
                                );
                              }}
                              onSetDeliveryOption={(deliveryOption) => {
                                onSetDeliveryOption(deliveryOption);
                              }}
                              onSetAddress={(address, billingAddress) =>
                                onSetAddress(address, billingAddress)
                              }
                              onSetRetailStore={(storePk, billingAddress) =>
                                onSetRetailStore(storePk, billingAddress)
                              }
                              onFetchCountries={() => onFetchCountries()}
                              onFetchCities={(pk, name) =>
                                onFetchCities(pk, name)
                              }
                              onFetchTownships={(pk) => onFetchTownships(pk)}
                              onFetchDistricts={(pk) => onFetchDistricts(pk)}
                              onSendAddress={(formData, pk) =>
                                onSendAddress(formData, pk)
                              }
                              onDeleteAddress={(pk) => onDeleteAddress(pk)}
                              error={error}
                            />
                          )}
                        </div>
                        <div className="col-xs-12 col-md-4 checkout-contents-wrapper__pl">
                          <CargoSelection
                            shippingOptions={context.shipping_options}
                            currentShippingOption={preOrder.shipping_option}
                            currentAddress={preOrder.shipping_address}
                            onSetShippingOption={(pk) =>
                              onSetShippingOption(pk)
                            }
                          >
                            <Button
                              classes={`button pointer text-center 
                                ${
                                  !preOrder.shipping_option &&
                                  !tabChangable &&
                                  "disabled"
                                }`}
                              onClick={() => changeTab(1)}
                            >
                              {$ST.SAVE_AND_CONTINUE}
                            </Button>
                          </CargoSelection>
                        </div>
                      </div>
                    </CheckoutContent>
                  )}
                  {tab === 1 && (
                    <CheckoutContent>
                      <div className="row">
                        <div className="col-12">
                          <PaymentSelection
                            qrUrl={qrUrl}
                            orderStatusUrl={orderStatusUrl}
                            context={context}
                            paymentOptions={context.payment_options}
                            currentPaymentOption={preOrder.payment_option}
                            redirect={context.redirect}
                            getBarcode={context.get_barcode}
                            handleCardSelection={handleCardSelection}
                            onSetPaymentOption={(pk) => {
                              onSetPaymentOption(pk);
                            }}
                            onSetPaymentType={(paymentType) =>
                              onSetPaymentType(paymentType)
                            }
                            onSelectInstallmentId={onSelectInstallmentId}
                            onSetInstallment={(pk) =>
                              onSetInstallmentOption(pk)
                            }
                            onSetInstallmentOption={(pk) =>
                              !!installmentId
                                ? onSelectInstallmentOption(pk)
                                : onSetInstallmentOption(pk)
                            }
                            onSetFundsTransferChoicePage={
                              onSetFundsTransferChoicePage
                            }
                            onSetPaymentFundTransfer={onSetPaymentFundTransfer}
                            error={error}
                          />
                        </div>
                      </div>
                    </CheckoutContent>
                  )}

                  {tab === 0 && $CT.HAS_GIFT_BOX_OPTIONS && (
                    <div className="giftBox-wrapper">
                      <p className="title">{$ST.GIFT_BOX.TITLE}</p>
                      <div className="checkbox-group">
                        <input
                          type="checkbox"
                          name="giftBoxCheck"
                          checked={giftBoxChecked}
                          onChange={(e) => {
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.checked,
                              },
                            });
                          }}
                        />
                        <label>{$ST.GIFT_BOX.DESCRIPTION}</label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-lg-3 checkout-wrapperPadding checkout-summary__wrapper">
              <CheckoutSummary
                discounts={
                  preOrder && preOrder.basket && preOrder.basket.discounts
                }
                total_amount={preOrder.unpaid_amount}
                total_product_amount={
                  preOrder.basket && preOrder.basket.total_product_amount
                }
                total_product_count={
                  preOrder.basket && preOrder.basket.total_quantity
                }
                currency_type={preOrder.currency_type_label}
                shipping_option={preOrder.shipping_option}
                installmentOptions={context && context.installment_options}
                installmentId={installmentId}
                cardId={cardId}
              >
                <Agreement
                  onAgreement={(checked) => {
                    onSetAgreement(checked);
                  }}
                  checked={agreement}
                  error={error}
                />
              </CheckoutSummary>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout(CheckoutGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/checkout/checkout/index.js